const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const RuleServiceCommand: any = {
    CreateCriteriaType: Backofficebff + '/v1/rule/criteriaType/create',
    GetCriteriaTypeList: Backofficebff + '/v1/rule/criteriaType/list',
    CreateRuleTemplate: Backofficebff + '/v1/rule/ruleTemplate/create',
    GetRuleTemplateList: Backofficebff + '/v1/rule/ruleTemplate/list',
    CreateRule: Backofficebff + '/v1/rule/rule/create',
    GetRuleList: Backofficebff + '/v1/rule/rule/list',
    CriteriaTypeDelete: Backofficebff + '/v1/rule/criteriaType/delete',
    DeleteRuleTemplate: Backofficebff + '/v1/rule/ruletemplate/delete',
};
